import { Input, InputNumber, Select } from "antd";
import React, { useState } from "react";

const VOICE_SCORE = [1, 2, 3, 4, 5, 6];

const SkillSetControl = ({
  label,
  voiceScore,
  setVoiceScore,
  writtenScore,
  setWrittenScore,
  error,
}) => {
  return (
    <div className="space-y-4 text-sm font-medium">
      {(label?.toLowerCase() === "voice" ||
        label?.toLowerCase() === "both") && (
        <div className="flex flex-col">
          <label className="text-gray-700">Minimum Voice Proficiency</label>
          <Select
            showSearch
            className="filter-group-select w-100 p-0 outline-none bg-white cutom_select_advance"
            placeholder="Select Minimum Voice Proficiency"
            value={voiceScore}
            optionFilterProp="children"
            filterOption={(input, option) => {
              const search = input.toLowerCase();
              return (
                String(option?.children ?? "")
                  .toLowerCase()
                  .includes(search) ||
                String(option?.value ?? "")
                  .toLowerCase()
                  .includes(search)
              );
            }}
            onChange={(value) => {
              setVoiceScore(value);
            }}
          >
            {VOICE_SCORE?.map((score) => {
              return <Select.Option value={score}>{`V${score}`}</Select.Option>;
            })}
          </Select>
          {error?.voiceScore && (
            <p className="text-red-500">{error?.voiceScore}</p>
          )}
        </div>
      )}

      {(label?.toLowerCase() === "written" ||
        label?.toLowerCase() === "both") && (
        <div className="flex flex-col">
          <label className="text-gray-700">Minimum Written Score (1-100)</label>
          <Input
            type="number"
            value={writtenScore}
            onChange={(e) => {
              const val = e.target.value;
              if (!val) {
                setWrittenScore(null);
                return;
              }

              if (Number(val) >= 1 && Number(val) <= 100) {
                setWrittenScore(val);
              }
            }}
            className="!w-full"
            placeholder="Enter Minimum Written Score"
          />
          {error?.writtenScore && (
            <p className="text-red-500">{error?.writtenScore}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SkillSetControl;
